export default {"src":"/_next/static/media/nomad-logo-mark_on-light.34456bae.svg","height":72,"width":50,"blurWidth":0,"blurHeight":0};